import { HubConnection, HubConnectionState } from '@microsoft/signalr';

export async function waitForConnectionState(
  connection: HubConnection,
  state: HubConnectionState = HubConnectionState.Connected,
  timeout: number = 100,
  attempts: number = 10,
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (connection.state === HubConnectionState.Connected) {
      resolve(true);
    } else if (attempts > 0) {
      setTimeout(async () => {
        resolve(waitForConnectionState(connection, state, timeout, attempts - 1));
      }, timeout);
    } else {
      reject(`picking up connection timed out after ${attempts} attempts`);
    }
  });
}
